import React, { useState, useEffect } from 'react';
import {
    Sheet,
    Table,
    Typography,
    Box,
    CircularProgress,
    Card,
    Chip
} from '@mui/joy';
import Pagination from '@mui/material/Pagination';
import axios from 'axios';
import domain from "../../../util/domain";

export default function FeedbackList() {
    const [feedback, setFeedback] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 10;

    useEffect(() => {
        const fetchFeedback = async () => {
            try {
                setLoading(true);
                const offset = (page - 1) * limit;
                const response = await axios.get(`${domain}/frontoffice/feedback/feedback`, {
                    params: { limit, offset }
                });
                setFeedback(response.data);
                const totalCount = parseInt(response.headers['x-total-count'] || '0');
                setTotalPages(Math.ceil(totalCount / limit));
            } catch (error) {
                console.error('Error fetching feedback:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchFeedback();
    }, [page]);

    const getRatingColor = (rating, type) => {
        if (type === 'response' || type === 'interaction') {
            if (rating >= 4) return 'success';
            if (rating >= 3) return 'warning';
            return 'danger';
        }
        return rating === 1 ? 'success' : 'neutral';
    };

    if (loading) return <CircularProgress />;

    return (
        <Box>
            <Sheet variant="outlined" sx={{ borderRadius: 'md', overflow: 'auto' }}>
                <Table stickyHeader hoverRow>
                    <thead>
                        <tr>
                            <th style={{ width: '20%' }}>Student Name</th>
                            <th style={{ width: '15%' }}>Response Rating</th>
                            <th style={{ width: '15%' }}>Counsellor Clarity</th>
                            <th style={{ width: '10%' }}>Needs Info</th>
                            <th style={{ width: '15%' }}>Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {feedback.map((item) => (
                            <tr key={item.id}>
                                <td>
                                    <Typography level="body-sm">
                                        {item.student_name}
                                    </Typography>
                                </td>
                                <td>
                                    <Chip
                                        size="sm"
                                        variant="soft"
                                        color={getRatingColor(item.response_rating, 'response')}
                                    >
                                        {item.response_rating}/4
                                    </Chip>
                                </td>
                                <td>
                                    <Chip
                                        size="sm"
                                        variant="soft"
                                        color={getRatingColor(item.counsellor_clarity, 'clarity')}
                                    >
                                        {item.counsellor_clarity ? 'Yes' : 'No'}
                                    </Chip>
                                </td>
                                <td>
                                    <Chip
                                        size="sm"
                                        variant="soft"
                                        color={getRatingColor(item.needs_more_info, 'info')}
                                    >
                                        {item.needs_more_info ? 'Yes' : 'No'}
                                    </Chip>
                                </td>
                                <td>
                                    <Typography level="body-sm">
                                        {new Date(item.createdAt).toLocaleDateString()}
                                    </Typography>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </Sheet>

            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mt: 2
                }}
            >
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={(event, value) => setPage(value)}
                />
            </Box>

            {feedback.length === 0 && (
                <Card
                    variant="outlined"
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        p: 3,
                        mt: 2
                    }}
                >
                    <Typography level="body-lg">
                        No feedback responses found
                    </Typography>
                </Card>
            )}
        </Box>
    );
} 